<template>
	<main class="privacy">
		<article class="privacy_info">
			<h6>개인정보 처리방침</h6>
			<div
				v-dompurify-html="terms?.data.terms.tos_content ?? '개인정보 불러오는 중'"
				class="content_body c_editorContent"
			></div>
		</article>
	</main>
</template>

<script setup lang="ts">
// core
import { ref, watch } from 'vue';

// api
import { useGetTermsApi } from '@/api/mypage';
// util
import { handleLinkClick } from '@/utils/directive/editorLinkOpenNewTab';

// -----variable-----
const contentBody = ref<HTMLDivElement | null>(null);

// -----api-----
const { data: terms } = useGetTermsApi({ tos_type: 'privacy' });

// editor 링크 클릭 시 새창 열기
// COMMENT : AOS에서는 target: _blank로 새창을 띄울 수 없어 추가된 코드입니다.
watch(
	[terms],
	() => {
		contentBody.value = document.querySelector('.c_editorContent');

		if (contentBody.value) {
			// 기존 리스너 제거
			contentBody.value.removeEventListener('click', handleLinkClick);

			// 새로운 리스너 추가
			contentBody.value.addEventListener('click', handleLinkClick);
		}
	},
	{ immediate: true }
);
</script>

<style lang="scss" scoped>
.privacy {
	max-width: 60rem;
	width: 100%;
	margin: 0 auto;
	padding-top: var(--header-height);
	margin-top: 8rem;
	margin-bottom: 2rem;
	@media screen and (max-width: 1280px) {
		margin-top: 4rem;
		padding: var(--header-height) 2rem 0rem 2rem;
	}
	.privacy_info {
		display: flex;
		flex-direction: column;
		gap: var(--space-xxx-large);

		.content_body {
			font-weight: var(--font-w-light);
			font-size: var(--font-s-regular);
			line-height: 2.3rem;
		}
	}
}
</style>
